<template>
  <UInput id="txt_table_searchfilter" v-model="searchTerm" :class="class" :placeholder="$t(placeholder)"  :ui="{base: 'text-xs'}" />
</template>

<script lang="ts" setup>
const searchTerm = defineModel<string>({ default: '' })

const props = withDefaults(
  defineProps<{
    class?: string,
    placeholder?: string
  }>(),
  {
    class: 'max-w-sm',
    placeholder: 'common.search_placeholder'
  }
)

</script>